// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app {\n  margin-top: var(--marginIos);\n}\n\n.child {\n  font-size: 0.8rem;\n}\n\n.menu-gesture {\n  --background: var(--header);\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
